<template lang='pug'>
    fieldset( :class='{ disabled: disabled }' style="border:0" )
        v-container( crud-form-fieldset fluid grid-list-lg pt-4 px-4 :pb-0="collapseBottom" )
            v-layout( row wrap )
                template( v-for="item in items" )
                    v-flex( v-bind='item.flex || defaultFlex' py-0 ) 
                        strong( 
                            class="grey--text text--darken-2" 
                            style='font-size:16px' 
                            v-if='!noLabels || item.prependLabel' 
                        ) {{ item.props.label }}

                        //
                        component(
                            :color="item.props.color || 'primary'" 
                            :is="item | type" 
                            :outline="item | outline"
                            single-line 
                            :readonly="disabled || item.props.readonly"
                            :ref="item.name"
                            v-bind="item.props"
                            v-model="value[item.name]"
                            @input="trigger(item)"
                            @selected="$emit( 'selected', selected( $event, item ) )"
                            @removed="$emit( 'removed', $event )"
                        )
                            template( v-if="item.props.reverse" )
                                strong( class='mr-1 mt-1' slot='append' v-if='noLabels || !item.noPrepend' ) {{ item.props.label }}
                            template( v-else )
                                strong( class='mr-1 mt-1' slot='prepend-inner' v-if='noLabels || !item.noPrepend' ) {{ item.props.label }}
                            
                            //
                            //template( v-if='item.slots' )
                            template( :slot='slotKey' v-for='(slotName, slotKey) in item.slots' slot-scope='props' )
                                slot( :name='slotName' v-bind='props' )

</template>

<script>
    //
    import { VAutocomplete, VCombobox, VDatePicker, VDivider, VSelect, VSwitch, VTextarea, VTextField, VCheckbox } from "vuetify/lib"
    import { VCard } from "vuetify/lib"
    import VAutocompleteModel from './ModelAutocomplete'
    import VCurrencyField from './Fields/CurrencyField'
    import VFloatField from './Fields/FloatField'
    import VPercentageField from './field-percentage'
    import VDateField from './Fields/DateField'
    import VItemField from './Fields/ItemField'
    import VPasswordField from './Fields/PasswordField'
    import VRutField from './Fields/RutField'
    import VRutInput from '../RUTInput/RUTInput'
    import VSectionField from './SectionField'
    import VCardTitleSection from './CardTitleSection'
    import VTimeField from './Fields/TimeField'
    //
    export default {
        nme: "crud-form-fieldset",
        components: {
            VAutocompleteModel,
            VAutocomplete,
            VCard,
            VCardTitleSection,
            VCombobox,
            VCurrencyField,
            "v-data-table-model": () => import( "./ModelDataTable" ),
            VDateField,
            VDatePicker,
            VDivider,
            VFloatField,
            VItemField,
            VPasswordField,
            VPercentageField,
            VRutField,
            VRutInput,
            VSectionField,
            VSelect,
            VSwitch,
            VTableField: () => import( './Fields/TableField' ),
            VTextarea,
            VTextField,
            VTimeField,
            VCheckbox,
        },
        created () {

            /**
             * 
             */
            this.defaultFlex = {
                lg3: true,
                md4: true,
                sm6: true,
                xs12: true,
            }
            
            /**
             * 
             */
            this.defaultNoFlex = {
                sm3: true,
            }
        },
        filters: {

            /**
             * 
             */
            format: ( field ) => ({
                name: String(field.name),
                type: String(field.type),
                flex: {
                    ...field.flex | {
                        xs12: true,
                        sm6: true,
                        md4: true,
                        lg2: true,
                    }
                },
                props: {
                    
                },
            }),

            /**
             * 
             */
            outline: ({ props }) => props.outline === undefined || props.outline,

            /**
             * 
             */
            type: ({ type }) => type ? ["v", type].join("-") : "div",
        },
        methods: {

            /**
             * 
             */
            selected ( $event, item ) {
                return {
                    ...$event,
                    name: item.name,
                }
            },

            /**
             * 
             */
            trigger ({ trigger }) {


                if ( typeof trigger === "function" ) {
                    switch (this.variant) {
                        case 'tabs': return trigger( this.$parent.$parent.$parent.$parent.$parent.$parent, this.items, this.value )
                        default: return trigger( this.$parent.$parent, this.items, this.value )
                    }                    
                }
            },
        },
        props: {

            /**
             * 
             */
            collapseBottom: Boolean,

            /**
             * 
             */
            disabled: Boolean,

            /**
             * 
             */
            noLabels: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            items: {
                type: Array,
                default: () => [],
            },

            /**
             * 
             */
            value: {
                type: Object,
                default: () => ({}),
            },

            /**
             * 
             */
            variant: String,
        },
    }
</script>

<style>
    .crud-form-fieldset .v-input__slot:hover {
        border-color: #00000080 !important;
    }

    .crud-form-fieldset .v-input__slot {
        border-color: #00000040 !important;
        transition: all ease .125s !important;
    }

    .crud-form-fieldset .v-input__slot .v-input__prepend-inner ,
    .crud-form-fieldset .v-input__slot .v-input__append-inner {
        white-space: nowrap;
    }

    /*.crud-form-fieldset .v-text-field--reverse .v-text-field__suffix {
        padding-top: 2px;
    }*/
    
    .crud-form-fieldset .v-select__selection.v-select__selection--comma {
        margin-bottom: 4px;
    }
    
    fieldset.disabled .crud-form-fieldset {
        pointer-events: none;
    }

    fieldset.disabled .crud-form-fieldset .v-datatable * {
        pointer-events: all ! important;
    }
</style>